import React, { useRef } from 'react';
import style from './index.module.css';
import Rheostat, { PublicState } from 'rheostat';
import ProgressBar from './progress_bar';
import Handle from './handle';
import Background from './background';
import { isFinite } from 'lodash';
import { amountToString } from '../../utils/strUtils';

type Props = {
    onChange?: ({ values }: PublicState) => void;
    min: number;
    max: number;
    sliderPricePosLow: number;
    sliderPricePosHigh: number;
    orientation?: 'horizontal' | 'vertical';
};

export const RangeSlider = ({ onChange, min, max, sliderPricePosLow, sliderPricePosHigh, orientation }: Props) => {
    const isActive = sliderPricePosLow !== min || sliderPricePosHigh !== max;
    const isDisabled = min === max;
    const refPriceLow = useRef<HTMLSpanElement>(null);
    const refPriceHigh = useRef<HTMLSpanElement>(null);

    return (
        <div className={style.filterContainer}>
            <div className={`${style.sliderWrapper} ${isDisabled ? style.disabled : ''}`}>
                <Rheostat
                    min={min}
                    max={max}
                    values={[sliderPricePosLow, sliderPricePosHigh]}
                    onChange={onChange}
                    disabled={isDisabled}
                    progressBar={({ style }) => ProgressBar({ style, isActive, isDisabled, orientation })}
                    onValuesUpdated={({ values }) => {
                        if (refPriceLow && refPriceLow.current) {
                            refPriceLow.current.innerHTML = `${
                                isFinite(values[0]) ? amountToString(values[0], 'USD') : values[0]
                            }`;
                        }
                        if (refPriceHigh && refPriceHigh.current) {
                            refPriceHigh.current.innerHTML = `${
                                isFinite(values[1]) ? amountToString(values[1], 'USD') : values[1]
                            }`;
                        }
                    }}
                    handle={(props) => Handle({ isActive, isDisabled, ...props })}
                    background={(props) => Background(props)}
                />
            </div>
            <div className={style.sliderValues}>
                <span ref={refPriceLow}>
                    {isFinite(sliderPricePosLow) ? amountToString(sliderPricePosLow, 'USD') : sliderPricePosLow}
                </span>
                <span ref={refPriceHigh}>
                    {isFinite(sliderPricePosHigh) ? amountToString(sliderPricePosHigh, 'USD') : sliderPricePosHigh}
                </span>
            </div>
        </div>
    );
};

export default RangeSlider;
